module.exports = "/assets/data/7ac41780bc95160d99cb612c080fa2bf-LL30.data.json";